import { motion } from 'framer-motion'
import { Activity, Clock, Server, CheckCircle2, ArrowDown } from 'lucide-react'

export function AuditabilitySection() {
  return (
    <section className="py-24 sm:py-32 bg-ground border-t border-line relative overflow-hidden">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 relative z-10 grid lg:grid-cols-2 gap-16 items-center">
        
        <div>
          <h2 className="text-3xl sm:text-4xl font-semibold text-ink tracking-tight mb-4">
            Every action is on the record.
          </h2>
          <p className="text-lg text-ink-muted leading-relaxed">
            See exactly what the assistant requested, what tool ran, what it returned, how long it took and what it cost. A complete developer observability interface for your AI workflows.
          </p>
        </div>

        <div className="relative">
          <div className="absolute -inset-4 bg-primary/5 blur-xl -z-10 rounded-3xl" />
          <div className="bg-surface border border-line rounded-xl p-6 shadow-pop overflow-hidden font-mono text-xs sm:text-sm select-none">
            
            {/* Timeline Entry */}
            <motion.div initial={{ opacity: 0, y: 10 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} className="flex flex-col gap-3">
              <div className="flex items-center gap-4 text-ink-muted border-b border-line pb-3">
                <span className="flex items-center gap-1.5"><Clock className="w-3.5 h-3.5" /> 14:32:08</span>
                <span className="flex items-center gap-1.5"><Server className="w-3.5 h-3.5" /> github.get_repository</span>
              </div>
              
              <div className="grid grid-cols-[100px_1fr] gap-2 pt-2 text-ink">
                <div className="text-ink-muted">Arguments</div>
                <div className="bg-ground border border-line px-2 py-1 rounded text-ink-faint">
                  {`{ "repo": "acme/backend" }`}
                </div>
              </div>

              <div className="flex justify-center py-1">
                <ArrowDown className="w-4 h-4 text-line-strong" />
              </div>

              <div className="grid grid-cols-[100px_1fr] gap-2 items-center">
                <div className="text-ink-muted">Response</div>
                <div className="flex items-center gap-2 text-ok bg-ok/10 border border-ok/20 px-2 py-1 rounded w-fit">
                  <CheckCircle2 className="w-3.5 h-3.5" /> 200 OK
                </div>
              </div>

              <div className="grid grid-cols-3 gap-4 border-t border-line mt-2 pt-4">
                <div>
                  <div className="text-ink-muted mb-1 text-[10px] uppercase">Latency</div>
                  <div className="text-ink">182ms</div>
                </div>
                <div>
                  <div className="text-ink-muted mb-1 text-[10px] uppercase">Credits</div>
                  <div className="text-ink">0.42</div>
                </div>
                <div>
                  <div className="text-ink-muted mb-1 text-[10px] uppercase">Status</div>
                  <div className="flex items-center gap-1 text-ok"><Activity className="w-3.5 h-3.5"/> Success</div>
                </div>
              </div>
            </motion.div>

          </div>
        </div>

      </div>
    </section>
  )
}
